import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../form/TextField';
import { handleBlurEvent } from '../../utilities/utilities';

export const EmailInputComponent = React.forwardRef(({
  value,
  onChange,
  error,
  errorMessage,
}, ref) => (
  <TextField
    id="in-page-lead-form-email-input"
    label='Email'
    ref={ref}
    name='email'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={handleBlurEvent}
    required={true}
    customTheme={'leads'}
    maxLength={200} />
));

EmailInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default EmailInputComponent;
